<template>
  <section id="view-emr-order" v-loading="loading">
    <div class="container-default">
      <div class="emr-status-navbar">
        <el-row type="flex" align="middle" style="width: 100%;">
          <el-col :span="18">
            <ul
              class="emr-result ml-5"
              v-if="this.caseInfo && this.caseInfo.created_at"
            >
              <li v-if="this.caseInfo && this.caseInfo.result_status">
                <span class="name">EMR Result Status</span>
                <span class="value" v-if="caseInfo.result_status == 'PENDING'">{{
                  this.caseInfo ? this.caseInfo.result_status : "--"
                }}</span>
                <span class="value COMPLETED" v-if="caseInfo.result_status == 'SENT'">{{
                  this.caseInfo ? this.caseInfo.result_status : "--"
                }}</span>
                <span class="value CANCELLED" v-if="caseInfo.result_status == 'CANCELLED'">{{
                  this.caseInfo.result_status ? "REJECTED" : "--" }}</span>
              </li>
              <li v-if="
                this.caseInfo.accession_data &&
                this.caseInfo.accession_data.length
              ">
                <div class="accesionidBlock">
                  <span  class="name">Accession Id</span>
                  <div class="accesionID">
                  <span v-for="(item, index) of caseInfo.accession_data" :key="index" class="value cursor"
                    @click="goToCaseView(item.case_id)">{{ item.accession_id }}</span>
                    </div>
                </div>
              </li>
              <li>
                <span class="name">Order Created On</span>
                <span class="value">{{
                  momentWithTimezone(this.caseInfo.created_at, "MM-DD-yyyy")
                }}
                  {{ momentWithTimezone(this.caseInfo.created_at, "hh:mm a") }}
                </span>
              </li>
              <li v-if="this.caseInfo && this.caseInfo.order_placed_at">
                <span class="name">Order Placed On</span>
                <span class="value" v-if="this.caseInfo && this.caseInfo.order_placed_at">{{
                  momentWithTimezone(this.caseInfo.order_placed_at, "MM-DD-yyyy")
                }}
                  {{ momentWithTimezone(this.caseInfo.order_placed_at, "hh:mm a") }}
                </span>
                <span v-else>--</span>
              </li>
              <li v-if="this.caseInfo.result_sent_on">
                <span class="name">Result Sent On</span>
                <span class="value COMPLETED">
                  {{
                    momentWithTimezone(
                      this.caseInfo.result_sent_on,
                      "MM-DD-yyyy"
                    )
                  }}
                  {{
                    momentWithTimezone(this.caseInfo.result_sent_on, "hh:mm a")
                  }}
                </span>
              </li>
            </ul>
          </el-col>
          <el-col :span="6">
            <ul class="emr-order-status">
              <li v-if="this.caseInfo && this.caseInfo.status">
                <span class="name">Order Status</span>
                <span class="value" v-if="caseInfo.status == 'ACTIVE'">
                  OPEN
                </span>
                <span class="value COMPLETED" v-else-if="caseInfo.status == 'COMPLETED'">FINALIZED
                </span>
                <span class="value CANCELLED" v-else-if="caseInfo.status == 'CANCELLED'">REJECTED</span>
                <span class="value" v-else>{{ caseInfo.status }}</span>
              </li>
              <li>
                <el-button class="value CANCELLED" @click="askReason = true"
                  v-if="isAbleToReject && hasPermission('emr_orders', 'reject')"><i
                    class="el-icon-circle-close"></i>Reject EMR</el-button>
              </li>
            </ul>
          </el-col>
        </el-row>
      </div>

      <div class="emr-tabs">
        <ul class="view-emr-tabs-list">
          <li>
            <router-link v-if="$route.params && $route.params.order_id" :to="{
              name: 'View-Case-Information',
              params: $route.params,
              query: this.$route.query,
            }" :class="getActiveClasstList('view-case-information')">
              <span>
                <img src="@/assets/img/icons/EMR/case-information.svg" alt="icon" class="non-active-icon" />
                <img src="@/assets/img/icons/EMR/case-information-active.svg" alt="icon" class="active-icon" />
              </span>
              Case Information</router-link>
          </li>
          <li v-if="
            (caseInfo && caseInfo.status == 'COMPLETED') ||
            (getSingleEMROrderReports && getSingleEMROrderReports.length)
          ">
            <router-link :to="{
              name: 'Finalized-Reports',
              params: $route.params,
              query: this.$route.query,
            }" :class="getActiveClasstList('finalized-reports')">
              <span>
                <img src="@/assets/img/icons/EMR/finalize-report.svg" alt="" class="non-active-icon" />
                <img src="@/assets/img/icons/EMR/finalize-report-active.svg" alt="" class="active-icon" />
              </span>
              Finalized Reports</router-link>
          </li>
        </ul>
        <div class="tabs-content">
          <router-view :layout="layout"></router-view>
        </div>
      </div>
    </div>

    <!-- Dialogs -->
    <div class="default-modal">
      <el-dialog title="Reason" v-model="askReason" width="30%" v-loading="loading">
        <div class="dialog-header">
          <span class="header-part">
            <img src="@/assets/images/reason.svg" alt="icon" />
            Reason
          </span>
          <el-button size="medium" class="el-white" type="info" plain @click="askReason = false">
            <img src="@/assets/images/close-icon.svg" alt="icon" /></el-button>
        </div>
        <el-row :gutter="20" class="popup-text-area pb-0">
          <el-col :span="24">
            <h4>Notes *</h4>
            <el-input type="textarea" rows="2" v-model="emrNotes" placeholder="Notes"></el-input>
            <p><b>Note:</b> Minimum 3 characters is required</p>
          </el-col>

          <el-col :span="24">
            <div class="dialog-footer">
              <el-button class="cancel-button" @click="askReason = false">Cancel</el-button>
              <el-button class="blue-save-button" :disabled="!haveNotes"
                :title="haveNotes ? 'Reject EMR' : 'Notes is Required'" @click="rejectEmr">Reject EMR</el-button>
            </div>
          </el-col>
        </el-row>
      </el-dialog>
    </div>
  </section>
</template>

<script>
import { mapGetters } from "vuex";
import {
  successNotification,
  errorNotification,
} from "@/helpers/notifications";
import { startLoading } from "@/helpers/loadingHelper";
import UserPermissionsHelper from "@/mixins/UserPermissionsHelper";
export default {
  data() {
    return {
      layout: "div",
      loading: false,
      emrNotes: "",
      askReason: false,
      askEmrConfig: false,
    };
  },
  mixins: [UserPermissionsHelper],
  computed: {
    Reason() {
      if (this.emrNotes && this.emrNotes.length >= 3) {
        return true;
      }

      return false;
    },
    haveNotes() {
      return this.emrNotes && this.emrNotes.trim().length >= 3;
    },
    caseInfo() {
      return this.getSingleEMROrder;
    },
    getQueryParams() {
      if (this.$route.query && Object.keys(this.$route.query).length) {
        return this.$route.query;
      }
      return {};
    },
    orderId() {
      if (this.$route.params && this.$route.params.order_id) {
        return this.$route.params.order_id;
      }
      return null;
    },
    disableEditRoutes() {
      if (
        (!this.$route.params || !this.$route.params.order_id) &&
        this.getSingleEMROrder &&
        this.getSingleEMROrder.status == "COMPLETED"
      ) {
        return true;
      }
      return false;
    },
    getActiveClasstList() {
      return (path) => {
        if (path == this.$route.path.split("/").pop()) {
          return "router-link-exact-active";
        } else return "";
      };
    },
    isAbleToReject() {
      if (!this.caseInfo && this.getSingleEMROrder) return true;
      return (
        this.caseInfo &&
        this.caseInfo.status != "COMPLETED" &&
        this.caseInfo.status != "CANCELLED" &&
        this.caseInfo.status != "QUEUED" &&
        this.caseInfo.status != "ARCHIVED"
      );
    },
    ...mapGetters("orders", [
      "getLocalPatient",
      "getCaseInformation",
      "getUpdateCaseStatus",
      "getPreviousStepForAllOrders",
    ]),
    ...mapGetters("emrOrders", [
      "getSingleEMROrder",
      "getSendReportStatus",
      "getSendReportErrors",
      "getSingleEMROrderReports",
    ]),
    ...mapGetters("auth", ["getAuthenticatedUser"]),
    ...mapGetters("cases", ["getPreviousStepForAllCases"]),

    restrictedAccess() {
      if (this.getAuthenticatedUser) {
        return (
          [
            "HOSPITAL_ADMIN",
            "HOSPITAL_ACCOUNT_MANAGER",
            "HOSPITAL_PHYSICIAN",
            "ACCOUNT_MANAGER",
          ].indexOf(this.getAuthenticatedUser.user_type) == -1
        );
      }
      return true;
    },
    checkAllowForTheUser() {
      return this.restrictedAccess && this.caseInfo.status == "ACTIVE";
    },
    queryParametersForLocalPatient() {
      if (this.$route.query.new_patient) {
        return { new_patient: true };
      }
      return {};
    },
    previousStepForAllOrders() {
      return this.getPreviousStepForAllCases || 1;
    },
  },
  mounted() {
    this.$store.dispatch("emrOrders/clearNewCaseData");
    this.getCaseData();
  },
  methods: {
    goToCaseView(case_id) {
      this.$router.push({
        name: "CaseView",
        params: { case_id: case_id },
        query: this.$route.query,
      });
    },
    async getCaseData() {
      try {
        const loading = startLoading();
        if (this.orderId) {
          await this.$store.dispatch("emrOrders/fetchSingleEMROrder", {
            order_id: this.orderId,
          });

          await this.$store.dispatch("emrOrders/fetchFinalizedReportsData", {
            order_id: this.orderId,
          });
        }
        loading.close();
      } catch (error) {
        console.log(error);
      }
    },

    // reject EMR
    async rejectEmr() {
      try {
        this.loading = true;
        await this.$store.dispatch("emrOrders/sendReportToEmr", {
          notes: [this.emrNotes],
          result_status: "CANCELLED",
          order_id: this.getSingleEMROrder._id,
          emr_order_id: this.getSingleEMROrder._id,
        });
        if (this.getSendReportStatus) {
          this.askReason = false;
          this.emrNotes = "";
          successNotification("EMR rejected successfully");
          window.location.reload();
        } else {
          errorNotification("Error in rejecting EMR");
        }
        this.loading = false;
      } catch (err) {
        console.log(err);
        this.loading = false;
      }
    },
  },
};
</script>

<style lang="scss">
#view-emr-order {
  padding: 0;
  .container-default{
        padding: 10px 30px 70px;
  }

  .emr-status-navbar {
    display: flex;
    align-items: center;
    background: #fff;
    justify-content: space-between;
    border-top: 1.2px solid #e7e7f7;
    border-bottom: 1.2px solid #e7e7f7;
        border-radius: 5px;
    padding: 2px 1px;
    font-size: 14px;

    @mixin button-style {
      padding: 0 10px;
      font-size: 14px;
      border-radius: 4px;
      font-weight: 500;
      height: 25px;
      min-height: auto;
      text-transform: uppercase;
      display: inline-flex;
      align-items: center;
      justify-content: center;
    }
    .accesionidBlock{
      display: flex;
      .name{
        flex: none;
      }
      .accesionID{
        display: flex;
        flex-wrap: wrap;
        row-gap: 7px;
        align-items: flex-start;
      }
    }

    .name {
      color: rgba(37, 33, 59, 0.8);
      text-transform: capitalize;
      margin-right: 10px;
      font-weight: 500;
    }

    .value {
      border: 0.6px solid #5162fd;
      color: #5162fd;
      margin-right: 10px;
      @include button-style();
      margin-right: 7px;
      font-size: 12.5px;

      &.COMPLETED {
        background: #f2f2f2;
        border: 0.6px solid #4bb543;
        color: #4bb543;
      }

      &.CANCELLED {
        background: #f2f2f2;
        border: 0.6px solid #eb5757;
        color: #eb5757;
      }
    }

    .emr-result {
      display: flex;
      align-items: center;
      flex-wrap: wrap;

      li {
        margin: 5px 0;

        &:not(:last-child) {
          margin-right: 10px;
        }
      }
    }

    .emr-order-status {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      flex-wrap: wrap;

      li {
        margin: 5px 0;

        &:not(:last-child) {
          margin-right: 10px;
        }

        button {
          @include button-style();
        }

        .text-danger {
          @include button-style();
          background-color: #fe7968;
          border: none;
        }
      }
    }
  }

  .emr-tabs {

    .view-emr-tabs-list {
      display: flex;
      flex-wrap: wrap;
      margin:1rem 0;
      li {
        a {
          background: #ffffff;
          border: 0.72px solid #dedbdb;
          border-radius: 5px;
          padding: 5px 15px;
          margin: 0 10px 0 0;
          color: #4f4f4f;
          transition: all 0.2s ease-in-out;

          img {
            margin-right: 3px;
          }

          .active-icon {
            display: none;
            transition: all 0.2s ease-in-out;
          }

          &:hover,
          &.router-link-exact-active {
            color: #ffffff;
            background: #273480;
            border-color: #273480;

            .active-icon {
              display: inline-block;
              transition: all 0.2s ease-in-out;
            }

            .non-active-icon {
              display: none;
            }
          }
        }
      }
    }

    .emr-tabs {
      .el-tabs__header {
        margin: 15px 0 10px;
      }

      .el-tabs__header .el-tabs__nav-wrap::after {
        display: none;
      }

      .el-tabs__item {
        background: #ffffff;
        border: 0.72px solid #dedbdb;
        border-radius: 5px;
        padding: 0 20px;

        color: #4f4f4f;
        margin: 5px;
      }

      .el-tabs__item:hover {
        color: #4f4f4f;
      }

      .el-tabs__item.is-active {
        color: #ffffff;
        background: #0a5da6;
        border: 0.5px solid #0a5da6;
        border-radius: 5px;
        padding: 0 20px;
      }

      .el-tabs__active-bar {
        display: none;
      }
    }

    .tabs-content {
      .case-creation__card {
        background: transparent;
      }

      .case-creation__heading,
      .case-creation__body {
        background: #fff;
      }

      .title-block {
        display: none;
      }

      .steps-data-view {
        background: #fff;
        padding: 20px;

        .title-with-icon {
          margin-bottom: 5px;

          .title {
            font-size: 1.1em;
            color: #0a5da6;
          }
        }
      }
    }
  }

  .case-creation__body {
    position: relative;
  }

  .edit-btn {
    position: absolute;
    right: 10px;
    border: none;
    z-index: 99;
    right: 15px;
    padding: 0;
    top: -3px;

    background-color: transparent;
    color: #828282;

    .edit-icon {
      img {
        position: relative;
        top: 2.5px;
      }
    }
  }

  .pregancy-field {
    display: flex;
    align-items: center;
    margin-top: 15px;

    label {
      font-weight: 500;
      font-size: 15px;
      line-height: 100%;
      color: #000000;
    }

    .el-checkbox {
      height: auto;
      position: relative;
      top: 3px;
      left: 10px;
    }

    .el-checkbox-group {
      .el-checkbox {
        height: 20px;
      }

      .el-checkbox__input .el-checkbox__inner {
        border-color: transparent;
        box-shadow: 0 0 0 1px #ced1d6;
        border-radius: 4px;
        width: 17px;
        height: 17px;
      }

      .el-checkbox__input.is-checked .el-checkbox__inner {
        background: #273480;
        border-color: #ffffff;
        box-shadow: 0 0 0 1px #ced1d6;
        width: 17px;
        height: 17px;
      }

      .el-checkbox__inner::after {
        box-sizing: content-box;
        content: "";
        border: 2px solid var(--el-checkbox-checked-icon-color);
        border-left: 0;
        border-top: 0;
        height: 9px;
        left: 5px;
        position: absolute;
        top: 1px;
        transform: rotate(45deg) scaleY(1);
        width: 3px;
        transition: transform 0.15s ease-in 50ms;
        transform-origin: center;
      }

      .el-checkbox__label {
        color: #34495e;
      }
    }
  }
}
</style>
